/* Mas Laus: užuomina "slinkite, kad pamatytumėte daugiau" po horizontaliais atsiliepimų sąrašais (pagrindinis ir produktų puslapiai) */
(function () {
  var css = '.ml-sh{display:flex;flex-direction:column;align-items:center;gap:.6rem;margin:1.1rem auto 0;padding:0 1rem;color:var(--ml-gold-deep,#8a6a3a);transition:opacity .3s}' +
    '.ml-sh[hidden]{display:none}.ml-sh.is-end .ml-sh__row{opacity:.35}' +
    '.ml-sh__row{display:flex;align-items:center;gap:.55rem;font-size:.72rem;letter-spacing:.14em;text-transform:uppercase;font-weight:500;transition:opacity .3s}' +
    '.ml-sh__a{width:1.6rem;height:.8rem;flex:none;stroke:currentColor;fill:none;stroke-width:1.4;stroke-linecap:round;stroke-linejoin:round;animation:ml-sh-nudge 1.6s ease-in-out infinite}' +
    '.ml-sh.is-end .ml-sh__a{animation:none}' +
    '.ml-sh__bar{position:relative;display:block;width:min(12rem,50vw);height:2px;background:rgba(32,27,82,.14);border-radius:2px;overflow:hidden}' +
    '.ml-sh__bar i{position:absolute;top:0;bottom:0;left:0;width:30%;background:var(--ml-gold,#c49e63);border-radius:2px;transition:left .15s,width .15s}' +
    '@keyframes ml-sh-nudge{0%,100%{transform:translateX(0)}50%{transform:translateX(5px)}}' +
    '@media(prefers-reduced-motion:reduce){.ml-sh__a{animation:none}}';
  function init() {
    var lists = document.querySelectorAll('.mlr__list,.mlp__list');
    if (!lists.length) return;
    if (!document.getElementById('ml-sh-css')) {
      var st = document.createElement('style'); st.id = 'ml-sh-css'; st.textContent = css; document.head.appendChild(st);
    }
    lists.forEach(function (l) {
      if (l.dataset.mlSh) return; l.dataset.mlSh = 1;
      var wrap = l.parentElement;
      var h = document.createElement('div');
      h.className = 'ml-sh';
      h.setAttribute('aria-hidden', 'true');
      h.innerHTML = '<span class="ml-sh__row"><span>Slinkite, kad pamatytumėte daugiau</span>' +
        '<svg class="ml-sh__a" viewBox="0 0 24 12"><path d="M1 6h21M17 1l5 5-5 5"/></svg></span>' +
        '<span class="ml-sh__bar"><i></i></span>';
      wrap.insertAdjacentElement('afterend', h);
      var thumb = h.querySelector('i');
      function upd() {
        var max = l.scrollWidth - l.clientWidth;
        if (max < 4) { h.hidden = true; return; }
        h.hidden = false;
        var w = Math.max(12, l.clientWidth / l.scrollWidth * 100);
        thumb.style.width = w + '%';
        thumb.style.left = (l.scrollLeft / max * (100 - w)) + '%';
        h.classList.toggle('is-end', l.scrollLeft > max - 4);
      }
      l.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      window.addEventListener('load', upd);
      upd();
      setTimeout(upd, 800);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();